@if (useRijksVersion()) {
  <ng-container [ngTemplateOutlet]="rijksTemplate" />
}

<ng-template #rijksTemplate>
  <div class="login-wrapper">
    <header class="login-wrapper__header">
      <dsrks-hero
        [variant]="logoVariant"
        [logoUrl]="logoUrl"
        [logoAltText]="logoAltText"
        logoWidth="258"
        logoHeight="125"
      />
      <dsrks-topbar variant="rijks">
        <ng-container ngProjectAs="left">
          <p class="topbar-title">Bevestiging wachtwoord mail</p>
        </ng-container>
      </dsrks-topbar>
    </header>
    <div class="login-wrapper__content">
      <div class="login-wrapper__content__bg-image"></div>
      <div class="login-wrapper__message">
        <p>We hebben u een mail gestuurd met een link voor het instellen van uw wachtwoord.</p>
      </div>
    </div>
  </div>
</ng-template>
